import React, { useEffect, useState } from "react";
import CreateBtn from "../../components/buttons/createBtn";
import VersionHistoryBtn from "../../components/buttons/versionHistoryBtn";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import searcher from "../../assets/icons/searchInput.svg";
import "./manufacturer.css";
import ManufacturerListTable from "./manufacturer-list-table";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ManufacturerPremiumTable from "./premium-user/manufacturer-premium-table";

const ManufacturerList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const status = queryParamsData.get("status") ?? "";
  const search = queryParamsData.get("search") ?? "";
  const [userData, setUserData] = useState(null);
  const user_type = localStorage.getItem("userType");

  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Manufacturer" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  const url = location.pathname;
  const pathArray = url.split("/");
  const activePath = "/" + pathArray[1];
  const activeSubPath = "/" + pathArray[2];

  const queryParams = [];
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <MainLayout breadCrumb="ADMIN  /  Manufacturer">
        <div>
          <div className="search-container d-flex justify-content-between ">
            <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
              <img className="styled-SVG" src={searcher} color={""} alt="o" />
              <input
                value={search}
                className="search-input fs_14 fw_400 text-dark px-2"
                type="text"
                placeholder="Search manufacturers here by manufacturer ID, manufacturer name..."
                onChange={(e) => {
                  navigate(
                    `/manufacturer${activeSubPath}?page=1${
                      e.target.value ? `&search=${e.target.value}` : ""
                    }${queryString}`
                  );
                }}
              />
            </div>

            <div className=" d-flex justify-content-between m-1 mb-2">
              <button
                onClick={() => navigate(`/manufacturer${activeSubPath}`)}
                className="py-1 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
              >
                Clear Filters
              </button>
              {activePath === "/manufacturer" &&
                activeSubPath === "/subscibe-list" && (
                  <VersionHistoryBtn link="/manufacturer/subscibe-list/version-list" />
                )}
              {activePath === "/manufacturer" &&
                activeSubPath === "/premium-list" && (
                  <VersionHistoryBtn link="/manufacturer/premium-list/version-list" />
                )}
              {(user_type === "super_admin" && userData?.write) ||
              user_type === "admin"
                ? activePath === "/manufacturer" &&
                  activeSubPath === "/subscibe-list" && (
                    <CreateBtn link="/manufacturer/subscibe-list/create" />
                  )
                : ""}
            </div>
          </div>
          {activePath === "/manufacturer" &&
            activeSubPath === "/subscibe-list" && (
              <ManufacturerListTable
                search={search}
                status={status}
                page_no={page_no}
              />
            )}
          {activePath === "/manufacturer" &&
            activeSubPath === "/premium-list" && (
              <ManufacturerPremiumTable
                search={search}
                status={status}
                page_no={page_no}
              />
            )}
        </div>
      </MainLayout>
    </>
  );
};

export default ManufacturerList;
